export default "__VITE_ASSET__BgicK69P__"